import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MailCheckIcon } from 'lucide-react';
import { EntryLayout } from '../../components/EntryLayout';
import { EntryField } from '../../components/EntryField';
import { StateScreen } from '../../components/StateScreen';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';

/** MOB/Auth/ForgotPassword. REQUIRES BACKEND: reset token generation and email. */
export function ForgotPassword() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  if (sent) {
    return <div className="min-h-screen w-full bg-sand pt-[max(12px,env(safe-area-inset-top))]" data-id="element-2420" data-mp="s2oqmcwfekli">
        <StateScreen tag={t('entry.forgot.sent.tag')} title={t('entry.forgot.sent.title')} body={t('entry.forgot.sent.body')} icon={<MailCheckIcon size={26} data-id="element-2422" data-mp="2mg6igc3v63mc" />} primary={{
        label: t('entry.forgot.back'),
        onClick: () => navigate('/entrar')
      }} data-id="element-2421" data-mp="2hhv69uq3jh0y" />
      </div>;
  }
  return <EntryLayout title={t('entry.forgot.title')} body={t('entry.forgot.body')} footer={<>
          <Button variant="gold" size="lg" fullWidth disabled={!email.includes('@')} onClick={() => setSent(true)} data-id="element-2424" data-mp="ejqr1bgwkj7r">
            {t('entry.forgot.submit')}
          </Button>
          <Button variant="quiet" size="lg" fullWidth className="mt-1" onClick={() => navigate('/entrar')} data-id="element-2425" data-mp="3d25pxndkqzux">
            {t('entry.forgot.back')}
          </Button>
        </>} data-id="element-2423" data-mp="3vzqgcyvzm6hn">
      <EntryField label={t('entry.forgot.email')} type="email" autoComplete="email" value={email} onChange={setEmail} data-id="element-2426" data-mp="3myil6porplrs" />
    </EntryLayout>;
}